import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const NAV_LINKS = [
  { to: "/", label: "首页" },
  { to: "/works", label: "作品列表" },
  { to: "/authors", label: "作者专区" },
  { to: "/about", label: "关于我们" },
];

export default function Navbar() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  const isHome = pathname === "/";
  const solid = !isHome || scrolled || open;

  const goSubscribe = () => {
    setOpen(false);
    if (pathname === "/") {
      document.getElementById("subscribe")?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/", { state: { scrollToSubscribe: true } });
    }
  };

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  const textCls = solid ? "text-foreground-800" : "text-background-100";

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        solid
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 md:h-[68px] max-w-7xl items-center justify-between px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2.5" aria-label="漫蛙漫画网 首页">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-xl text-sm font-bold ${
              solid ? "bg-primary-500 text-background-50" : "bg-background-50/95 text-primary-700"
            }`}
          >
            蛙
          </span>
          <span className={`font-heading text-lg font-extrabold tracking-tight ${textCls}`}>
            漫蛙漫画网
          </span>
        </Link>

        <div className="hidden items-center gap-1 md:flex">
          {NAV_LINKS.map((l) => {
            const active = l.to === "/" ? pathname === "/" : pathname.startsWith(l.to);
            return (
              <Link
                key={l.to}
                to={l.to}
                className={`rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                  active
                    ? solid
                      ? "bg-primary-100 text-primary-700"
                      : "bg-background-50/20 text-background-50"
                    : solid
                      ? "text-foreground-700 hover:bg-background-100 hover:text-primary-700"
                      : "text-background-100 hover:bg-background-50/20 hover:text-background-50"
                }`}
              >
                {l.label}
              </Link>
            );
          })}
        </div>

        <div className="hidden items-center gap-3 md:flex">
          <button
            type="button"
            onClick={goSubscribe}
            className={`whitespace-nowrap rounded-full px-5 py-2.5 text-sm font-semibold transition-colors ${
              solid
                ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                : "bg-accent-500 text-background-50 hover:bg-accent-600"
            }`}
          >
            <i className="ri-notification-3-line mr-1.5" aria-hidden="true" />
            追更提醒
          </button>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="打开菜单"
          aria-expanded={open}
          className={`flex h-10 w-10 items-center justify-center rounded-lg text-xl md:hidden ${
            solid ? "text-foreground-800" : "text-background-50"
          }`}
        >
          <i className={open ? "ri-close-line" : "ri-menu-line"} aria-hidden="true" />
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          <div className="flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className="rounded-lg px-3 py-3 text-sm font-medium text-foreground-800 hover:bg-background-100"
              >
                {l.label}
              </Link>
            ))}
            <button
              type="button"
              onClick={goSubscribe}
              className="mt-2 flex items-center justify-center rounded-full bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 hover:bg-primary-600"
            >
              <i className="ri-notification-3-line mr-1.5" aria-hidden="true" />
              追更提醒
            </button>
          </div>
        </div>
      )}
    </header>
  );
}